import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/case-studies.css';

const CaseStudiesLayout = ({
  children,
  title = 'Case Studies',
  description = 'Selected TukeWIN client work, implementation context, and project outcomes.',
  locale = 'en',
  isMenuOpen,
  setIsMenuOpen,
  ogType = 'website',
}) => {
  return (
    <>
      <Helmet htmlAttributes={{ lang: locale }}>
        <title>{title} | TukeWIN</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={`${title} | TukeWIN`} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content={ogType} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${title} | TukeWIN`} />
        <meta name="twitter:description" content={description} />
      </Helmet>

      <div className="case-studies-shell min-h-screen bg-slate-900 text-white">
        <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <main className="case-studies-main">
          {children}
        </main>
        <Footer />
      </div>
    </>
  );
};

export default CaseStudiesLayout;
